export const Top7Filled = () => {
    return (
        <svg width="82" height="107" viewBox="0 0 82 107" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.68607 106.053L52.4088 21.9681H6.07826L9.33699 0.946903H80.8873L77.9119 20.4266L27.6142 106.053H1.68607Z"
                fill="#1D252D"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.51518 0H82L78.8312 20.7464L28.1651 107H0L50.7228 22.915H4.96288L8.51518 0ZM10.1586 1.89381L7.19348 21.0212H54.0947L3.37197 105.106H27.0631L76.9925 20.1068L79.7744 1.89381H10.1586Z"
                fill="url(#paint0_linear_14434_27249)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_14434_27249"
                    x1="33.9635"
                    y1="-35.0354"
                    x2="33.9635"
                    y2="147.717"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#3A4755" />
                </linearGradient>
            </defs>
        </svg>
    );
};
